import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Login = ({ onToggleForm }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { signIn } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = await signIn(email, password);

    if (error) {
      setError(error.message);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      {/* Columna izquierda - Video de demostración */}
      <div className="auth-demo-section">
        <div className="demo-content">
          <h1 className="demo-title">Bienvenido a JAM CIRCLE</h1>
          <p className="demo-subtitle">
            Descubre música, comparte tus letras favoritas y conecta con otros amantes de la música
          </p>

          <div className="video-container">
            <a
              href="https://collection.cloudinary.com/diysqyres/bcce9ecc2314d77a6b9a6534b6f1fbbe"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '400px',
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                borderRadius: '16px',
                color: 'white',
                textDecoration: 'none',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 10px 40px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ fontSize: '80px', marginBottom: '20px' }}>🎬</div>
              <h3 style={{ fontSize: '24px', marginBottom: '10px', fontWeight: 'bold' }}>
                Ver Video Demo
              </h3>
              <p style={{ fontSize: '16px', opacity: 0.8 }}>
                Haz clic para ver cómo funciona JAM CIRCLE
              </p>
              <div style={{
                marginTop: '20px',
                padding: '12px 30px',
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 'bold'
              }}>
                ▶ Reproducir Demo
              </div>
            </a>
          </div>

          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">🎵</span>
              <span className="feature-text">Crea y comparte playlists</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🎤</span>
              <span className="feature-text">Publica tus letras favoritas</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">👥</span>
              <span className="feature-text">Conecta con amigos</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">⭐</span>
              <span className="feature-text">Califica y comenta canciones</span>
            </div>
          </div>
        </div>
      </div>

      {/* Columna derecha - Formulario de login */}
      <div className="auth-form-section">
        <div className="auth-form">
          <h2 className="auth-form-title">Iniciar Sesión</h2>
          <p className="auth-form-description">Ingresa a tu cuenta para continuar</p>

          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
                placeholder="tu@email.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="auth-submit-button"
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>

          <div className="auth-toggle">
            <p>
              ¿No tienes cuenta?{' '}
              <button type="button" className="link-button" onClick={onToggleForm}>
                Regístrate aquí
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;